import styled from "styled-components";

export const PermissionTableContainer = styled.div`
  overflow: auto;
  height: 50vh;
`;
